export default __webpack_public_path__ + "static/media/puzzle.b7a87d10.webp";